import Vue from 'vue'
import { ItemService } from '@/services'
import apiRecent from './api'
import { Message } from 'element-ui'

const PAGE_SIZE = 50

const namespaced = true

const state = {
  files: [],
  nextToken: undefined,
  busy: false,
  showRecent: false
}

const getters = {
  recentFiles: state => state.files,
  recentBusy: state => state.busy,
  showRecent: state => state.showRecent,
  hasNextToken: state => !!state.nextToken
}

const actions = {
  getRecentFiles ({ state, commit, dispatch }, update = false) {
    if (state.files.length && update) return
    commit('setBusy', true)
    apiRecent
      .getRecentFiles({ nextToken: state.nextToken, pageSize: PAGE_SIZE })
      .then(ItemService.decodeItems)
      .then(({ items, nextToken }) => {
        items.forEach(file => {
          dispatch('setFile', file)
        })
        commit('setNextToken', nextToken)
        commit('setBusy', false)
      })
      .catch(() => {
        commit('setBusy', false)
        Message({
          type: 'error',
          message: 'Oops, we were unable to fetch your files',
          showClose: true
        })
      })
  },
  clearRecentFiles ({ commit }) {
    commit('clearRecentFiles')
  },
  toggleShowRecent ({ commit }) {
    commit('toggleShowRecent')
  },
  setFile ({ commit }, file) {
    if (file.status === 2) {
      commit('removeFile', file)
    } else {
      commit('setFile', file)
    }
  },
  removeFile ({ commit }, file) {
    commit('removeFile', file)
  }
}

const mutations = {
  clearRecentFiles (state) {
    Vue.set(state, 'files', [])
    Vue.set(state, 'nextToken', undefined)
  },
  setFile (state, file) {
    const fileIndex = state.files.findIndex(f => {
      return f.id === file.id
    })

    if (fileIndex > -1) {
      state.files.splice(fileIndex, 1)
    }
    state.files.push(file)
  },
  setBusy (state, value) {
    Vue.set(state, 'busy', value)
  },
  setNextToken (state, value) {
    if (state.nextToken !== value) {
      Vue.set(state, 'nextToken', value)
    }
  },
  toggleShowRecent (state) {
    state.showRecent = !state.showRecent
  },
  removeFile (state, file) {
    const fileIndex = state.files.findIndex(f => {
      return f.id === file.id
    })

    if (fileIndex > -1) {
      state.files.splice(fileIndex, 1)
    }
  },
  updateFile (state, file) {
    const fileIndex = state.files.findIndex(f => {
      return f.id === file.id
    })

    if (fileIndex > -1) {
      state.files.splice(fileIndex, 1, file)
    }
  }
}

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations
}
